module.exports = __webpack_public_path__ + "media/metronic/_theme/media/products/product1-42bb28e12c443c981643d06a110825de.jpg";